export var FileExtensionEnum;
(function (FileExtensionEnum) {
    FileExtensionEnum["PDF"] = "application/pdf";
    FileExtensionEnum["JPG"] = "image/jpeg";
    FileExtensionEnum["TIFF"] = "image/tiff";
})(FileExtensionEnum || (FileExtensionEnum = {}));
